import {
  toastTypes,
  performanceConstants,
} from "../../constants";
import { customToast } from "../../../../shared";
import { performanceService } from "../../services";
import {
  success,
  failure,
  withSpinner,
} from "../../../../redux/actions/utilities";

const {
  ALL_BRAND_RESPONSE_DATA,
  GET_INBOX_CONVERSATION_DATA,
  CUSTOMER_RESPONSES_EXPORT_ALL_DATA,
  ALL_BRAND_CONVERSION_RESPONSE_DATA,
  GET_INBOX_CONVERSATION_DATA_EXPORT,
  GET_INBOX_CONVERSATION_SUMMARY_DATA,
  GET_INBOX_CONVERSATION_DATA_BY_BRAND_ID,
  SURVEY_CONVERSION_RATE_KPI_SUMMARY_DATA,
  GET_ALL_BRANDS_CONVERSION_RESPONSES_FOR_EXPORT,
} = performanceConstants;

//Get all brands responses
const getAllBrandsResponses = (createDateFrom, createDateTo, body) => {
  return (dispatch) => {
    withSpinner(dispatch, ALL_BRAND_RESPONSE_DATA, () =>
      performanceService
        .getAllBrandsResponses(createDateFrom, createDateTo, body)
        .then(
          (response) => {
            dispatch(success(response, ALL_BRAND_RESPONSE_DATA));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

const getAllBrandResponsesItemsForExport = (
  createDateFrom,
  createDateTo,
  body
) => {
  return (dispatch) => {
    withSpinner(dispatch, ALL_BRAND_RESPONSE_DATA, () =>
      performanceService
        .getAllBrandsResponses(createDateFrom, createDateTo, body)
        .then(
          (response) => {
            dispatch(
              success(
                response.pageData.result,
                CUSTOMER_RESPONSES_EXPORT_ALL_DATA
              )
            );
          },
          (error) => {
            dispatch(resetAllExportItems());
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

const resetAllExportItems = () => {
  return (dispatch) => {
    dispatch(failure([], CUSTOMER_RESPONSES_EXPORT_ALL_DATA));
  };
};

const getAllBrandsConversionResponses = (
  createDateFrom,
  createDateTo,
  body
) => {
  return (dispatch) => {
    withSpinner(dispatch, ALL_BRAND_CONVERSION_RESPONSE_DATA, () =>
      performanceService
        .getAllBrandsConversionResponses(createDateFrom, createDateTo, body)
        .then(
          (response) => {
            dispatch(success(response, ALL_BRAND_CONVERSION_RESPONSE_DATA));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            dispatch(failure(error, ALL_BRAND_CONVERSION_RESPONSE_DATA));
          }
        )
    );
  };
};

const getSurveyConversionRateKpiSummary = (createDateFrom, createDateTo) => {
  return (dispatch) => {
    withSpinner(dispatch, SURVEY_CONVERSION_RATE_KPI_SUMMARY_DATA, () =>
      performanceService
        .getSurveyConversionRateKpiSummary(createDateFrom, createDateTo)
        .then(
          (response) => {
            dispatch(success(response, SURVEY_CONVERSION_RATE_KPI_SUMMARY_DATA));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            dispatch(failure(error, SURVEY_CONVERSION_RATE_KPI_SUMMARY_DATA));
          }
        )
    );
  };
};

const getAllBrandsConversionResponsesForExport = (
  createDateFrom,
  createDateTo,
  body
) => {
  return (dispatch) => {
    withSpinner(dispatch, ALL_BRAND_CONVERSION_RESPONSE_DATA, () =>
      performanceService
        .getAllBrandsConversionResponses(createDateFrom, createDateTo, body)
        .then(
          (response) => {
            dispatch(
              success(
                response.data,
                GET_ALL_BRANDS_CONVERSION_RESPONSES_FOR_EXPORT
              )
            );
          },
          (error) => {
            dispatch(resetAllExportItems());

            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

const getInboxConversationData = (
  createDateFrom,
  createDateTo,
  platformId,
  body
) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_INBOX_CONVERSATION_DATA, () =>
      performanceService
        .getInboxConversationData(createDateFrom, createDateTo, platformId, body)
        .then(
          (response) => {
            dispatch(success(response, GET_INBOX_CONVERSATION_DATA));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            dispatch(failure(error, GET_INBOX_CONVERSATION_DATA));
          }
        )
    );
  };
};

const getInboxConversationSummary = (
  createDateFrom,
  createDateTo,
  orderPlatformType
) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_INBOX_CONVERSATION_SUMMARY_DATA, () =>
      performanceService
        .getInboxConversationSummary(
          createDateFrom,
          createDateTo,
          orderPlatformType
        )
        .then(
          (response) => {
            dispatch(success(response, GET_INBOX_CONVERSATION_SUMMARY_DATA));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            dispatch(failure(error, GET_INBOX_CONVERSATION_SUMMARY_DATA));
          }
        )
    );
  };
};

const getInboxConversationDataByBrandId = (
  createDateFrom,
  createDateTo,
  brandId,
  from,
  take
) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_INBOX_CONVERSATION_DATA_BY_BRAND_ID, () =>
      performanceService
        .getInboxConversationDataByBrandId(
          createDateFrom,
          createDateTo,
          brandId,
          from,
          take
        )
        .then(
          (response) => {
            dispatch(success(response, GET_INBOX_CONVERSATION_DATA_BY_BRAND_ID));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            dispatch(failure(error, GET_INBOX_CONVERSATION_DATA_BY_BRAND_ID));
          }
        )
    );
  };
};

const getInboxConversationDataForExport = (
  createDateFrom,
  createDateTo,
  platformId,
  body
) => {
  return (dispatch) => {
    return withSpinner(dispatch, GET_INBOX_CONVERSATION_DATA_EXPORT, () =>
      performanceService
        .getInboxConversationData(createDateFrom, createDateTo, platformId, body)
        .then(
          (response) => response?.data,
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            dispatch(failure(error, GET_INBOX_CONVERSATION_DATA_EXPORT));
            throw error;
          }
        )
    );
  };
};

const resetConversionRateReducer = () => (dispatch) => {
  dispatch(failure([], ALL_BRAND_CONVERSION_RESPONSE_DATA));
  dispatch(failure([], SURVEY_CONVERSION_RATE_KPI_SUMMARY_DATA));
};

const resetInboxReportReducer = () => (dispatch) => {
  dispatch(failure([], GET_INBOX_CONVERSATION_DATA));
  dispatch(failure([], GET_INBOX_CONVERSATION_SUMMARY_DATA));
};
const resetStoresList = () => (dispatch) => {
  dispatch(failure([], GET_INBOX_CONVERSATION_DATA_BY_BRAND_ID));
};

export const performanceActions = {
  getAllBrandsResponses,
  getAllBrandResponsesItemsForExport,

  resetAllExportItems,
  resetConversionRateReducer,
  getAllBrandsConversionResponses,
  getSurveyConversionRateKpiSummary,
  getAllBrandsConversionResponsesForExport,

  resetStoresList,
  resetInboxReportReducer,
  getInboxConversationData,
  getInboxConversationSummary,
  getInboxConversationDataForExport,
  getInboxConversationDataByBrandId,
};
